import { render, staticRenderFns } from "./AppCounter.vue?vue&type=template&id=36b513f2&scoped=true&"
import script from "./AppCounter.vue?vue&type=script&lang=ts&"
export * from "./AppCounter.vue?vue&type=script&lang=ts&"
import style0 from "./AppCounter.vue?vue&type=style&index=0&id=36b513f2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b513f2",
  null
  
)

export default component.exports